import axios from "@common/api/desktop/axios";
import md5 from "md5";

export const fetchLogin = (username, password) => async (dispatch) => {
  const response = await axios.put(`Security/Login2/`, { username, password });

  const session = {
    ...response.data,
    ...{ email: username },
    hash: md5(password),
  };
  dispatch({
    type: "FETCH_LOGIN",
    payload: { ...session },
  });
};

/**
 * Reset a user's password
 * @param {string} username
 * @param {md5 hash} prevPassword
 * @param {string} password
 * @param {string} password2
 */
export const setPassword =
  (username, prevPassword, password, password2) => async () => {
    return await axios.put(`Security/SetPassword4/`, {
      username,
      prevPassword,
      password,
      password2,
    });
  };

export const resetPassword = (email) => async () => {
  try {
    await axios.put(`Security/ResetPassword/${email}`);
    return true;
  } catch (error) {
    return false;
  }
};

export const setLogout = () => async (dispatch) => {
  const callback = () => {
    sessionStorage.removeItem("login");
    dispatch({ type: "CLEAR_REDUX", payload: { logOut: true } });
  };

  axios.put(`Security/Logout`).then(callback, callback);
};
